export default __webpack_public_path__ + "b2da62f020089ccee92860e4defafdb4.png";